import axios from 'axios';
import {BASE_URL_STRING} from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  login: "account/dashboard/login",
  getTotalActiveStudents: "dashboard/students/active-total-count",
  getTotalInactiveStudents: "dashboard/students/inactive-total-count",
  getTotalStudents: "dashboard/students/total-count",
  getTotalLessons: "lessons/dashboard/total-count",
  getTotalActiveLessons: "lessons/dashboard/active-total-count",
  getTotalInactiveLessons: "lessons/dashboard/inactive-total-count",
  getTotalGeneratedCodes: "codes/dashboard/total-generated-codes-count",
  getTotalAccessCodes: "codes/dashboard/total-access-codes-count",
  getTotalActiveAccessCodes: "codes/dashboard/active-access-codes-count",
  getTotalInactiveAccessCodes: "codes/dashboard/inactive-access-codes-count",
};

export const createIdentityAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/" + endpoint + "/";
  const token = sessionStorage.getItem("token");
  return {
    fetch: () =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),

    post: (newRecord) => axios.post(url, newRecord),

    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putWithToken: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};
